import { FC } from 'react'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { prioritySchemaBadgeColors } from '@new/domains/operations/screens/CasesV2/CasesV2.constants'
import { FiltersProps } from '@new/domains/operations/screens/CasesV2/CasesV2.types'
import { parseLabel } from '@new/domains/operations/utils/parseLabel'

interface PriorityFilterProps extends FiltersProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

const options = Object.entries(prioritySchemaBadgeColors).map(([priority, badgeColor]) => ({
  value: priority,
  hasFullWidth: true,
  dot: badgeColor.color,
  label: parseLabel(priority),
}))

export const PriorityFilter: FC<PriorityFilterProps> = props => {
  return <CheckboxBasedFilter title="Priority" options={options} {...props} />
}
